import { useQuery, QueryOptions } from 'react-query';
import UnitService from '../../services/unitService';

const useEffectiveHudContractQuery = ({
  unitId,
  propertyId,
  organizationId,
  effectiveDate,
  enabled = true,
  options,
}: {
  unitId: string,
  propertyId: string,
  organizationId: string,
  effectiveDate?: string,
  enabled?: boolean,
  options?: QueryOptions,
}) => {
  return useQuery(
    ['effectiveHudContract', unitId, propertyId, organizationId, effectiveDate],
    () => {
      const unitService = new UnitService();
      return unitService.getEffectiveHudContract(
        propertyId,
        organizationId,
        unitId,
        effectiveDate,
      );
    },
    {
      ...options,
      enabled: Boolean(enabled && unitId && propertyId && organizationId),
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};

export default useEffectiveHudContractQuery;
